module.exports = __webpack_public_path__ + "static/media/photo55.a1ccc135.jpg";